<script>
import { getAccessToken, handleSuccess } from "@/utils/helpers";

export const ContextStateSymbol = Symbol('User settings state provider identifier');
export const ContextUpdateSymbol = Symbol('User settings update provider identifier');

export default {
  name: 'Context',
  data() {
    return {
      isOpen: false,
      isAuth: false,
      isSaved: false,
      step: 0,
      changeToken: null,
      email: null,
      userData: {},
      errorMessage: null,
      isProviderAuth: false,
    };
  },
  provide() {
    return {
      [ContextStateSymbol]: this.$data,
      [ContextUpdateSymbol]: this.update,
    };
  },
  watch: {
    isSaved() {
      setTimeout(() => {
        this.isSaved = false;
        this.errorMessage && (this.errorMessage = null);
      }, 5000);
    }
  },
  methods: {
    update(property, value) {
      this[property] = value;
      this.saveToStorage();
    },
    saveToStorage() {
      const isRemember = localStorage.getItem('cbgIsRemember');
      const storage = isRemember ? localStorage : sessionStorage;
      storage.setItem('cbgContext', JSON.stringify(this.$data));
    },
    async loadFromStorage() {
      const token = getAccessToken();
      const isRemember = localStorage.getItem('cbgIsRemember');

      const storageType = token && isRemember ? localStorage : sessionStorage;
      const storedData = storageType.getItem('cbgContext');

      if (storedData) {
        const parsedData = JSON.parse(storedData);

        if (cbgAuthUser[0] === 'guest' && (parsedData.userData && Object.keys(parsedData.userData).length)) {
          await handleSuccess('cbg_auth_login', {...parsedData.userData, isRemember});
        }

        Object.assign(this.$data, parsedData);
      } else {
        if (cbgAuthUser[0] === 'subscriber') {
          await handleSuccess('cbg_auth_logout', {});
        }
      }
    },
    checkScroll() {
      const width = window.innerWidth;
      const isOverflowVisible = !this.isOpen || (this.step === 0 && this.isAuth && width > 768);
      document.body.style.overflow = isOverflowVisible ? 'visible' : 'hidden';
    }
  },
  created() {
    this.loadFromStorage();
    this.checkScroll();

    this.$watch('$data', () => {
      this.checkScroll();
      this.saveToStorage();
    }, { deep: true });
  },
  render() {
    return this.$slots.default();
  },
};
</script>